export const about = {
  personalName: "KHEDID ABDELLAH",
  job: "Full-Stack Web, Mobile & AI Developer",
  descriptionFirstPart:
    "I build React and Next.js web applications, Flutter and React Native mobile products, Node.js services, and practical AI integrations.",
  from: "Italy",
};
